export class InventorySchema {
    public type: string;
    public subtype: string;
    public schema: object;
    public indexes: string[];
    public mainAttributes: Record<string, MainAttributesConfig>;
}

export class InventorySchemaList {
    public schemas: InventorySchema[];
    public totalSize: number;
}

export interface MainAttributesConfig {
    path: string;
    isPublic: boolean;
    indexed: boolean;
}
